<template>
  <header class="navbar">
    <div class="logo">
      AuthentiGuard
    </div>
    <nav class="nav-links">
      <router-link to="/">
        {{ $t('nav.home') }}
      </router-link>
      <!--      <router-link to="/verification">-->
      <!--        {{ $t('nav.verification') }}-->
      <!--      </router-link>-->
      <!--      <a href="javascript:void(0)" @click="scrollToStats">-->
      <!--        {{ $t('nav.achievements') }}-->
      <!--      </a>-->
      <router-link to="/report">
        {{ $t('nav.report') }}
      </router-link>
      <!--      <router-link to="/achievements">-->
      <!--        {{ $t('nav.achievements') }}-->
      <!--      </router-link>-->
      <!-- 修改成果链接，使用点击事件处理锚点 -->
      <a
        href="javascript:void(0)"
        @click="scrollToStats"
      >
        {{ $t('nav.achievements') }}
      </a>
      <router-link to="/calendar">
        {{ $t('nav.calendar') }}
      </router-link>
      <router-link to="/brand">
        {{ $t('nav.brands') }}
      </router-link>
<!--      <router-link-->
<!--        to="/cooperationCenter"-->
<!--      >-->
<!--        {{ $t('nav.cooperationCenter') }}-->
<!--      </router-link>-->
    </nav>
    <div class="nav-actions">
      <LanguageSwitch />
      <!--      <van-button-->
      <!--        type="primary"-->
      <!--        size="small"-->
      <!--        @click="goToAuth"-->
      <!--      >-->
      <!--        登录/注册-->
      <!--      </van-button>-->
    </div>
    <div
      class="mobile-menu-btn"
      @click="toggleMobileMenu"
    >
      <van-icon name="wap-nav" />
    </div>

    <!-- 移动端菜单 -->
    <div
      v-show="showMobileMenu"
      class="mobile-menu"
      @click="toggleMobileMenu"
    >
      <div
        class="mobile-menu-content"
        @click.stop
      >
        <nav class="mobile-nav-links">
          <router-link
            to="/"
            @click="closeMobileMenu"
          >
            {{ $t('nav.home') }}
          </router-link>
          <router-link
            to="/report"
            @click="closeMobileMenu"
          >
            {{ $t('nav.report') }}
          </router-link>
          <a
            href="javascript:void(0)"
            @click="handleMobileAchievementsClick"
          >
            {{ $t('nav.achievements') }}
          </a>
          <router-link
            to="/calendar"
            @click="closeMobileMenu"
          >
            {{ $t('nav.calendar') }}
          </router-link>
          <router-link
            to="/brand"
            @click="closeMobileMenu"
          >
            {{ $t('nav.brands') }}
          </router-link>
<!--          <router-link-->
<!--            to="/cooperationCenter"-->
<!--            @click="closeMobileMenu"-->
<!--          >-->
<!--            {{ $t('nav.cooperationCenter') }}-->
<!--          </router-link>-->
        </nav>

        <div class="mobile-nav-actions">
          <LanguageSwitch />
        </div>
      </div>
    </div>
  </header>
</template>

<script lang="ts">
import { useRouter, useRoute } from 'vue-router'
import { ref, inject, onMounted, onUnmounted } from 'vue'
import LanguageSwitch from '@/components/layout/LanguageSwitch.vue'
export default {
  name: 'NavBar',
  components: {
    LanguageSwitch
  },
  setup () {
    const router = useRouter()
    const route = useRoute()
    const showMobileMenu = ref(false)

    const goToAuth = () => {
      router.push('/auth')
    }

    const toggleMobileMenu = () => {
      showMobileMenu.value = !showMobileMenu.value
      // 这里可以添加移动端菜单的显示/隐藏逻辑
    }

    const scrollToStats = inject('scrollToStats') as () => void

    const handleAchievementsClick = () => {
      if (route.path !== '/') {
        router.push('/').then(() => {
          setTimeout(() => {
            scrollToStats?.()
          }, 100)
        })
      } else {
        scrollToStats?.()
      }
    }

    const closeMobileMenu = () => {
      showMobileMenu.value = false
      document.body.style.overflow = ''
    }

    const handleMobileAchievementsClick = () => {
      closeMobileMenu()
      handleAchievementsClick()
    }

    // 监听窗口大小变化，在大屏幕上自动关闭移动菜单
    const handleResize = () => {
      if (window.innerWidth > 768) { // 假设 $breakpoint-md 是 768px
        closeMobileMenu()
      }
    }
    // 点击菜单外部关闭菜单
    const handleClickOutside = (event: Event) => {
      const mobileMenu = document.querySelector('.mobile-menu-content')
      const menuBtn = document.querySelector('.mobile-menu-btn')

      if (showMobileMenu.value &&
          mobileMenu &&
          !mobileMenu.contains(event.target as Node) &&
          menuBtn &&
          !menuBtn.contains(event.target as Node)) {
        closeMobileMenu()
      }
    }

    onMounted(() => {
      window.addEventListener('resize', handleResize)
      document.addEventListener('click', handleClickOutside)
    })

    onUnmounted(() => {
      window.removeEventListener('resize', handleResize)
      document.removeEventListener('click', handleClickOutside)
      document.body.style.overflow = '' // 清理样式
    })
    return {
      goToAuth,
      toggleMobileMenu,
      showMobileMenu,
      scrollToStats: handleAchievementsClick,
      closeMobileMenu,
      handleMobileAchievementsClick
    }
  }
}

</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.navbar {
  background-color: $primary-blue;
  padding: $spacing-sm $spacing-xl;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: $z-index-sticky;
  box-shadow: $nav-shadow;
  height: $navbar-height;
}

.logo {
  font-size: $font-size-xl;
  font-weight: 700;
  color: $white;
}

.nav-links {
  display: flex;
  gap: $spacing-lg;

  a {
    color: rgba($white, 0.85);
    text-decoration: none;
    font-size: $font-size-sm;
    transition: color $transition-normal;

    &:hover {
      color: $accent-gold;
    }

    &.router-link-active {
      color: $accent-gold;
      font-weight: 600;
    }
  }
}

.nav-actions {
  display: flex;
  align-items: center;
  gap: $spacing-md;
}

.mobile-menu-btn {
  display: none;
  color: $white;
  font-size: $font-size-xl;
  cursor: pointer;
}

// 移动端菜单样式
.mobile-menu {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: $z-index-sticky;
  display: flex;
  justify-content: flex-end;
}

.mobile-menu-content {
  width: 70%;
  max-width: 300px;
  height: 100%;
  background-color: $primary-blue;
  padding: 80px $spacing-lg $spacing-lg;
  display: flex;
  flex-direction: column;
  animation: slideIn 0.3s ease-out;
}

.mobile-nav-links {
  display: flex;
  flex-direction: column;
  gap: $spacing-md;
  flex: 1;

  a {
    color: rgba($white, 0.85);
    text-decoration: none;
    font-size: $font-size-md;
    padding: $spacing-sm 0;
    transition: color $transition-normal;
    border-bottom: 1px solid rgba($white, 0.1);

    &:hover {
      color: $accent-gold;
    }

    &.router-link-active {
      color: $accent-gold;
      font-weight: 600;
    }
  }
}

.mobile-nav-actions {
  padding-top: $spacing-lg;
  border-top: 1px solid rgba($white, 0.1);
}

@media (max-width: $breakpoint-md) {
  .nav-links {
    display: none;
  }

  .mobile-menu-btn {
    display: block;
  }

  .mobile-nav-links {
    gap: $spacing-md;

    a {
      font-size: $font-size-md;
    }
  }
}

@media (max-width: $breakpoint-sm) {
  .navbar {
    padding: $spacing-sm;
  }

  .logo {
    font-size: $font-size-lg;
  }

  .mobile-nav-links {
    gap: $spacing-sm;

    a {
      font-size: $font-size-sm;
    }
  }
}

@media (max-width: $breakpoint-lg) {
  .navbar {
    padding: $spacing-lg;
  }

  .logo {
    font-size: $font-size-lg;
  }

  .mobile-nav-links {
    gap: $spacing-lg;

    a {
      font-size: $font-size-sm;
    }
  }
}

@media (max-width: $breakpoint-xl) {
  .navbar {
    padding: $spacing-lg;
  }

  .logo {
    font-size: $font-size-xl;
  }

  //.mobile-nav-links {
  //  gap: $spacing-xl;
  //
  //  a {
  //    font-size: $font-size-xl;
  //  }
  //}
}

@media (max-width: $breakpoint-xxl) {
  .navbar {
    padding: $spacing-lg;
  }

  .logo {
    font-size: $font-size-xxl;
  }

  //.mobile-nav-links {
  //  gap: $spacing-xxl;
  //
  //  a {
  //    font-size: $font-size-xxl;
  //  }
  //}
}
</style>
